/** GUID format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx (8-4-4-4-12 hex digits). */
export const GUID_FORMAT = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export const HEX_FORMAT = /^#[0-9a-f]{3,6}$/i;
// export const REGISTER_CODE_FORMAT = /^[a-zA-Z0-9]+$/;
export const REGISTER_CODE_FORMAT = /^[a-zA-Z0-9_-]+(\s+[a-zA-Z0-9_-]+)*$/;
export const BOOKING_CODE_FORMAT = /^([a-zA-Z0-9]{3}-[a-zA-Z0-9]{3})?$/;
export const DYNAMIC_VALUE_FORMAT = /{([a-zA-Z]+)}/g;
